var _linearGradient, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkillsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "128px",
    height: "128px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "stMYITnsBzu7K9XzUdIHAa",
    x1: 16,
    x2: 16,
    y1: 27.043,
    y2: 35.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ab4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e492ff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 32,
    r: 5,
    fill: "url(#stMYITnsBzu7K9XzUdIHAa)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "stMYITnsBzu7K9XzUdIHAb",
    x1: 31.998,
    x2: 31.998,
    y1: 3.425,
    y2: 51.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#stMYITnsBzu7K9XzUdIHAb)",
    d: "M54.364,41.636c-2.765-2.763-6.891-3.34-10.235-1.75l-1.078-1.078 c-0.887-0.886-2.286-1.069-3.397-0.568l-5.775-5.775c-0.175-0.175-0.371-0.32-0.565-0.465c0.195-0.145,0.391-0.29,0.565-0.465 l5.68-5.68c0.406,0.193,0.843,0.301,1.284,0.301c0.769,0,1.537-0.293,2.122-0.878l1.076-1.076c1.196,0.572,2.51,0.884,3.874,0.884 c2.403,0,4.664-0.937,6.363-2.637c3.509-3.509,3.509-9.219,0-12.728s-9.219-3.512-12.728,0c-1.7,1.699-2.637,3.96-2.637,6.363 c0,1.365,0.312,2.679,0.884,3.875l-1.076,1.075c-0.921,0.921-1.105,2.292-0.577,3.406l-5.68,5.68 C31.898,30.688,31.145,31,30.343,31h-1.527c-0.414-1.161-1.514-2-2.816-2h-1.525c-1.239-3.49-4.565-6-8.475-6c-4.963,0-9,4.037-9,9 s4.037,9,9,9c3.91,0,7.236-2.51,8.475-6H26c1.302,0,2.402-0.839,2.816-2h1.527c0.802,0,1.556,0.313,2.122,0.879l5.764,5.764 c-0.19,0.398-0.3,0.832-0.3,1.286c0,0.802,0.313,1.556,0.879,2.121l1.078,1.078c-1.591,3.344-1.015,7.471,1.75,10.236 c1.755,1.754,4.06,2.631,6.364,2.631s4.609-0.877,6.364-2.631C57.873,50.854,57.873,45.146,54.364,41.636z M42.965,11.136 c1.364-1.364,3.157-2.047,4.949-2.047c1.793,0,3.586,0.683,4.95,2.047c2.729,2.729,2.729,7.17,0,9.899 c-1.322,1.322-3.08,2.051-4.949,2.051c-1.87,0-3.628-0.729-4.95-2.051s-2.051-3.08-2.051-4.95 C40.914,14.216,41.643,12.458,42.965,11.136z M41.551,22.449c0.238,0.238,0.49,0.458,0.749,0.666l-0.749,0.749 c-0.379,0.378-1.036,0.377-1.415,0c-0.39-0.391-0.39-1.024,0-1.415l0.75-0.749C41.093,21.959,41.313,22.211,41.551,22.449z M16,39 c-3.859,0-7-3.141-7-7s3.141-7,7-7s7,3.141,7,7S19.859,39,16,39z M26,33h-1.059C24.978,32.671,25,32.338,25,32 s-0.022-0.671-0.059-1H26c0.552,0,1,0.448,1,1S26.552,33,26,33z M40.222,41.635c-0.189-0.188-0.293-0.438-0.293-0.706 c0-0.267,0.104-0.518,0.293-0.707c0.38-0.377,1.036-0.378,1.414,0l0.749,0.749c-0.258,0.207-0.51,0.426-0.749,0.665 c-0.239,0.239-0.458,0.49-0.665,0.749L40.222,41.635z M52.95,52.95c-2.729,2.729-7.171,2.729-9.9,0c-2.729-2.729-2.729-7.171,0-9.9 c2.73-2.729,7.172-2.729,9.9,0C55.679,45.779,55.679,50.221,52.95,52.95z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stMYITnsBzu7K9XzUdIHAc",
    x1: 48,
    x2: 48,
    y1: 3.425,
    y2: 51.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#stMYITnsBzu7K9XzUdIHAc)",
    d: "M48,21c1.336,0,2.592-0.521,3.535-1.465C52.479,18.592,53,17.336,53,16 s-0.521-2.592-1.465-3.535C50.592,11.521,49.336,11,48,11s-2.592,0.521-3.535,1.465C43.521,13.408,43,14.664,43,16 s0.521,2.591,1.465,3.535S46.664,21,48,21z M45.879,13.879C46.445,13.313,47.198,13,48,13s1.555,0.313,2.121,0.879S51,15.198,51,16 s-0.313,1.555-0.879,2.121c-1.133,1.133-3.109,1.133-4.242,0C45.313,17.555,45,16.802,45,16S45.313,14.445,45.879,13.879z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stMYITnsBzu7K9XzUdIHAd",
    x1: 48,
    x2: 48,
    y1: 3.425,
    y2: 51.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#stMYITnsBzu7K9XzUdIHAd)",
    d: "M51.535,44.465C50.592,43.521,49.336,43,48,43s-2.591,0.521-3.535,1.465S43,46.664,43,48 s0.521,2.592,1.465,3.535C45.408,52.479,46.664,53,48,53s2.592-0.521,3.535-1.465C52.479,50.592,53,49.336,53,48 S52.479,45.408,51.535,44.465z M50.121,50.121c-1.133,1.133-3.109,1.133-4.242,0C45.313,49.555,45,48.802,45,48 s0.313-1.555,0.879-2.121S47.198,45,48,45s1.555,0.313,2.121,0.879S51,47.198,51,48S50.688,49.555,50.121,50.121z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsIcon);
export default __webpack_public_path__ + "static/media/skills-icon.ca079f0c19c425e844078d5acfeb68f0.svg";
export { ForwardRef as ReactComponent };